"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup = __importStar(require("yup"));
const input_1 = require("./input");
// Conversation
exports.conversation = yup.object({
    id: input_1.id.required(),
});
exports.conversations = yup.object({
    eventTypes: yup.array(input_1.eventType),
    status: yup.array(input_1.conversationStatus),
});
// Message
exports.messages = yup.object({
    conversationId: input_1.id.required(),
    eventTypes: yup.array(input_1.eventType),
});
// PendingCase
exports.pendingCase = yup.object({});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3Vic2NyaXB0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3N1YnNjcmlwdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFLQSx5Q0FBMEI7QUFDMUIsbUNBQXlEO0FBRXpELGVBQWU7QUFDRixRQUFBLFlBQVksR0FBRyxHQUFHLENBQUMsTUFBTSxDQUErQjtJQUNqRSxFQUFFLEVBQUUsVUFBRSxDQUFDLFFBQVEsRUFBRTtDQUNwQixDQUFDLENBQUE7QUFDVyxRQUFBLGFBQWEsR0FBRyxHQUFHLENBQUMsTUFBTSxDQUFnQztJQUNuRSxVQUFVLEVBQUUsR0FBRyxDQUFDLEtBQUssQ0FBQyxpQkFBUyxDQUFDO0lBQ2hDLE1BQU0sRUFBRSxHQUFHLENBQUMsS0FBSyxDQUFDLDBCQUFrQixDQUFDO0NBQ3hDLENBQUMsQ0FBQTtBQUVGLFVBQVU7QUFDRyxRQUFBLFFBQVEsR0FBRyxHQUFHLENBQUMsTUFBTSxDQUEyQjtJQUN6RCxjQUFjLEVBQUUsVUFBRSxDQUFDLFFBQVEsRUFBRTtJQUM3QixVQUFVLEVBQUUsR0FBRyxDQUFDLEtBQUssQ0FBQyxpQkFBUyxDQUFDO0NBQ25DLENBQUMsQ0FBQTtBQUVGLGNBQWM7QUFDRCxRQUFBLFdBQVcsR0FBRyxHQUFHLENBQUMsTUFBTSxDQUFLLEVBQUUsQ0FBQyxDQUFBIn0=